import { render, staticRenderFns } from "./UnitNature.vue?vue&type=template&id=6b56219c&scoped=true&"
import script from "./UnitNature.vue?vue&type=script&lang=js&"
export * from "./UnitNature.vue?vue&type=script&lang=js&"
import style0 from "./UnitNature.vue?vue&type=style&index=0&id=6b56219c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b56219c",
  null
  
)

export default component.exports